import { AfterViewChecked, ChangeDetectionStrategy, Component, ElementRef, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { UiButtonSize, UiButtonType, UiButtonVariant } from './ui-button.types';

@Component({
  selector: 'ui-button',
  standalone: true,
  templateUrl: './ui-button.component.html',
  styleUrls: ['./ui-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiButtonComponent implements AfterViewChecked {
  private readonly host = inject(ElementRef<HTMLElement>);
  private readonly translate = inject(TranslateService);

  readonly variant = input<UiButtonVariant>('primary');
  readonly size = input<UiButtonSize>('md');
  readonly type = input<UiButtonType>('button');
  readonly disabled = input(false);
  readonly fullWidth = input(false);
  readonly ariaLabel = input('');
  readonly badgeText = input('');

  ngAfterViewChecked(): void {
    const label = this.host.nativeElement.querySelector('.ui-button__label') as HTMLElement | null;
    const raw = label?.textContent?.trim() ?? '';

    if (!label || !raw || label.children.length > 0) {
      return;
    }

    const source = label.dataset['sourceLabel'] ?? raw;
    label.dataset['sourceLabel'] = source;

    const key = `uiLabels.${this.toKey(source)}`;
    const translated = this.translate.instant(key);
    label.textContent = translated === key ? source : translated;
  }

  private toKey(value: string): string {
    return value
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/\+/g, ' plus ')
      .replace(/[^a-z0-9]+/g, '.')
      .replace(/^\.+|\.+$/g, '');
  }
}
